import React, { useEffect, useState } from 'react';

const OrientationLock = () => {
  const [isLandscape, setIsLandscape] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkOrientation = () => {
      setIsLandscape(window.innerWidth > window.innerHeight);
      // Only consider it mobile if width is less than 768px (typical tablet breakpoint)
      setIsMobile(window.innerWidth < 768);
    };

    // Check on mount
    checkOrientation();

    // Add event listener
    window.addEventListener('resize', checkOrientation);

    // Cleanup
    return () => window.removeEventListener('resize', checkOrientation);
  }, []);

  // Only show the lock screen if it's both landscape AND mobile
  if (!isLandscape || !isMobile) return null;

  return (
    <div className="orientation-lock">
      <div className="orientation-message">
        <i className="fa fa-mobile fa-rotate-90" style={{ fontSize: '48px', marginBottom: '20px' }}></i>
        <h2>Please rotate your device</h2>
        <p>This website is optimized for portrait mode only</p>
      </div>
      <style jsx>{`
        .orientation-lock {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: white;
          z-index: 9999;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
        }
        .orientation-message {
          padding: 20px;
        }
        .orientation-message h2 {
          margin-bottom: 10px;
          color: #333;
        }
        .orientation-message p {
          color: #666;
        }
      `}</style>
    </div>
  );
};

export default OrientationLock; 